// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"uI-z","carouselContainer":"vI-z"};